module.exports = __webpack_public_path__ + "img/d243590.jpg";